import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-phonefield', 'INVALID', 'Blogas telefono numerio formatas.');
Labels.set('ui-phonefield', 'CHOOSE_COUNTRY', 'Pasirinkite šalį');
Labels.set('ui-phonefield', 'PHONENR', 'Telefono numeris');
